import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { SupplierDetails } from '@suppliers/models/supplier-details';
import { MfsSupplierDetailsHttpService } from '@feature/suppliers/services/mfs-supplier-details-http.service';


@Injectable()
export class MfsSupplierDetailsService {

    constructor(
        private readonly mfsSupplierDetailsHttpService: MfsSupplierDetailsHttpService) {
    }

    getSupplierDetails(): Observable<SupplierDetails> {
        return this.mfsSupplierDetailsHttpService.getDetails();
    }

}

